import { render } from "./ConfigModal.vue?vue&type=template&id=148c1bab&scoped=true"
import script from "./ConfigModal.vue?vue&type=script&lang=js"
export * from "./ConfigModal.vue?vue&type=script&lang=js"

import "./ConfigModal.vue?vue&type=style&index=0&id=148c1bab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148c1bab"]])

export default __exports__